/**
 * Storage for tab communication
 */
class FJTabCommunication {
    constructor() {
        this._heartbeatKey = 'heartbeat';
        this._heartbeatTimeout = null;
        this._isMonitorHeartbeat = true;
    }

    // 设置localStorage的方法
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    // 获取localStorage的方法
    getItem(key) {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }

    // 监听localStorage变化的方法
    onStorageChange(key, callback) {
        window.addEventListener('storage', function (event) {
            if (event.key === key) {
                callback(JSON.parse(event.newValue));
            }
        });
    }
    onRemoveStorage(key, callback) {
        window.removeEventListener('storage', function (event) {
            if (event.key === key) {
                callback(JSON.parse(event.newValue));
            }
        });
    }

    // 开始心跳检测
    startHeartbeat(key, interval = 3000) {
        this.heartbeatInterval = setInterval(() => {
            this.setItem(this._heartbeatKey + key, Date.now());
        }, interval);
    }

    // 停止心跳检测
    stopHeartbeat() {
        clearInterval(this.heartbeatInterval);
    }

    // 监听心跳
    onHeartbeat(key, callback, timeout = 5000) {
        // 设置一个新的定时器
        this._heartbeatTimeout = setTimeout(() => {
            callback(false); // 如果在一定时间内没有接收到新的心跳，就调用回调函数并传入 false
            clearTimeout(this._heartbeatTimeout);
        }, timeout);
        this.onStorageChange(this._heartbeatKey + key, () => {
            // 清除上一个定时器
            clearTimeout(this._heartbeatTimeout);
            callback(true); // 如果在一定时间内没有接收到新的心跳，就调用回调函数并传入 false
        });
    }
    // 持续监听心跳的方法
    monitorHeartbeat(key, callback, timeout = 5000) {
        if (!this._isMonitorHeartbeat) return;
        this.onHeartbeat(
            key,
            isAlive => {
                if (!isAlive) {
                    callback();
                } else {
                    this.monitorHeartbeat(key, callback, timeout);
                }
            },
            timeout,
        );
    }
    stopMonitorHeartbeat() {
        this._isMonitorHeartbeat = false;
        clearTimeout(this._heartbeatTimeout);
    }
}

export default FJTabCommunication;
